<template>
  <div class="incoming-orders__wrap">
    <ShippingLabelPopup
      :isLoading="isLoading"
      :showLabelPopup="showLabelPopup"
      :isShowLabels="isShowLabels"
      :showLabels="showLabels"
      :replay="replay"
      :orders="orders"
    />
    <b-container>
      <div class="incoming-orders-configurator">
        <div class="incoming-orders-configurator__item-wrap">
          <span class="shipping-rule-configurator__text">{{
            $t("Select shop:")
          }}</span>
          <b-form-select
            v-model="selectedShop"
            :options="shops"
            @change="createNewOrders"
          ></b-form-select>
        </div>
        <b-button
          class="incoming-orders__button"
          @click="createLabel"
          variant="primary"
          :disabled="!selectedNumberOrders"
        >
          <font-awesome-icon icon="file-alt" />
          {{ $t("Create label") }}
        </b-button>
      </div>

      <div class="order-wrap">
        <div class="order-header">
          <div class="order-header-item order-header-item__checkbox">
            <label class="order-item__checkbox-label" for="all_orders">
              <input
                type="checkbox"
                class="order-item__checkbox"
                name="orders"
                id="all_orders"
                v-model="allOrdersSelected"
                @change="selectAllOrders"
              />

              <span class="order-item__checkbox-icon">
                <div
                  class="order-item__checkbox-hint"
                  v-if="!selectedNumberOrders"
                ></div>
              </span>
            </label>
          </div>
          <div class="order-header-item order-header-item__customer">
            {{ $t("Status") }}
          </div>
          <div class="order-header-item">{{ $t("Order no.") }}</div>
          <div class="order-header-item order-header-item__customer">
            {{ $t("Customer") }}
          </div>
          <div class="order-header-item">{{ $t("Carrier") }}</div>
        </div>
        <div class="order-item-wrap">
          <transition-group name="fade">
            <div
              class="order-item"
              v-for="order in orders"
              :key="order.customer.name"
            >
              <div class="order-item-column order-item-column__checkbox">
                <label class="order-item__checkbox-label" :for="order.number">
                  <input
                    type="checkbox"
                    class="order-item__checkbox"
                    name="orders"
                    :id="order.number"
                    :value="order.number"
                    v-model="selectedOrders"
                  />
                  <span class="order-item__checkbox-icon"></span>
                </label>
              </div>
              <div class="order-item-column order-item-column__customer">
                <div class="order-item-column__content-wrap">
                  <span
                    class="order-item__light"
                    :class="{
                      'order-item__light--active':
                        order.status === 'Ready to ship',
                    }"
                  ></span>
                  <span class="order-item__text">{{ order.status }}</span>
                </div>
                <small class="order-item__small-text text-muted">{{
                  order.subStatus
                }}</small>
              </div>

              <div class="order-item-column">
                <span class="order-item__text">{{ order.number }}</span>
              </div>
              <div class="order-item-column order-item-column__customer">
                <span class="order-item__text">{{ order.customer.name }}</span>
                <small class="order-item__small-text text-muted">
                  <img
                    class="order-item__country-logo"
                    :src="`https://flagcdn.com/w20/${order.country.code}.png`"
                  />
                  {{ order.country.name }}
                </small>
              </div>
              <div class="order-item-column">
                <img
                  :src="`${publicPath}carrier-logos/${order.carrier.logo}`"
                  class="order-item__carrier-logo"
                />
                <small class="order-item__small-text text-muted">{{
                  order.carrier.text
                }}</small>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { BContainer, BFormSelect, BButton } from "bootstrap-vue";
import ShippingLabelPopup from "@/components/ShippingLabelPopup.vue";
import { getCurrentLanguage } from "@/lang/i18n.js";

require("chance");

import { CARRIERS } from "@/constants/carriers.js";
import { COUNTRIES } from "@/constants/countries.js";

export default {
  name: "IncomingOrders",
  components: {
    ShippingLabelPopup,
    BContainer,
    BFormSelect,
    BButton,
  },
  computed: {
    selectedNumberOrders() {
      return this.selectedOrders.length || null;
    },
    selectedOrderInfo: (orderNo) =>
      this.orders.find((order) => order.number === orderNo),
  },
  data() {
    return {
      orders: [],
      selectedOrders: [],
      allOrdersSelected: false,
      selectedShop: "All shops",
      shops: {
        "all-shops": {
          text: "All shops",
          value: "All shops",
        },
        shopify: {
          text: "Shopify",
          value: "Shopify",
        },
        amazon: {
          text: "Amazon",
          value: "Amazon",
        },
        prestashop: {
          text: "Prestashop",
          value: "Prestashop",
        },
      },
      showLabelPopup: false,
      isLoading: false,
      isShowLabels: false,
      publicPath: process.env.BASE_URL,
    };
  },
  mounted() {
    this.createNewOrders();
  },
  methods: {
    generateRandomOrder() {
      return {
        customer: {
          name: chance.name(),
        },
        status: this.$t("Ready to process"),
        subStatus: this.$t("Label not yet printed"),
        country: chance.pickset(COUNTRIES)[0],
        number: chance.string({
          length: 8,
          casing: "upper",
          alpha: true,
          numeric: true,
        }),
        carrier: chance.pickset(CARRIERS[getCurrentLanguage()])[0],
        weight: chance.floating({ fixed: 1, min: 2, max: 120 }),
        value: chance.floating({ fixed: 2, min: 5, max: 500 }),
      };
    },
    createNewOrders() {
      this.selectedOrders = [];
      this.deselectAllorders();
      this.orders = [];
      for (let index = 0; index < 4; index++) {
        this.orders.unshift(this.generateRandomOrder());
      }
    },
    createLabel() {
      this.showLabelPopup = true;
      this.isLoading = true;
      setTimeout(this.setIsLoading, 1250);
    },
    setIsLoading() {
      this.isLoading = false;
    },
    selectAllOrders() {
      if (!this.allOrdersSelected) {
        return (this.selectedOrders = []);
      }
      this.selectedOrders = [
        this.orders[0].number,
        this.orders[1].number,
        this.orders[2].number,
        this.orders[3].number,
      ];
    },
    deselectAllorders() {
      this.allOrdersSelected = false;
    },
    showLabels() {
      this.isShowLabels = true;
      this.setOrderStatusToActive();
    },
    replay() {
      this.isShowLabels = false;
      this.showLabelPopup = false;
      this.createNewOrders();
    },
    setOrderStatusToActive() {
      this.selectedOrders.forEach((orderNo) => {
        this.orders.find((order) => order.number === orderNo).status =
          "Ready to ship";
      });
    },
  },
};
</script>

<style scoped>
.incoming-orders-configurator {
  width: 75%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (max-width: 992px) {
  .incoming-orders-configurator {
    flex-wrap: wrap;
    width: 100%;
  }
}

.incoming-orders__button {
  background-color: var(--sky-blue);
  border: none;
}

.incoming-orders__reset-button {
  margin-top: 60px;
  background: rgba(0, 0, 0, 0.3);
}

.shipping-rule-configurator__text {
  color: #717b90;
  flex-shrink: 0;
  margin-right: 12px;
  margin-left: 12px;
}

@media screen and (max-width: 992px) {
  .shipping-rule-configurator__text {
    margin-left: 0;
  }
}

.custom-select {
  border-radius: 25px;
  font-family: "BeatriceMedium";
  color: var(--full-blue);
  min-width: 150px;
}

.custom-select__last {
  margin-left: 12px;
}

@media screen and (max-width: 992px) {
  .custom-select__last {
    margin-left: 0;
  }
}

.incoming-orders-configurator__item-wrap {
  max-width: 40%;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  flex-grow: 1;
}

@media screen and (max-width: 992px) {
  .incoming-orders-configurator__item-wrap {
    width: 100%;
  }
}

.order-header {
  display: flex;
}
.order-header-item {
  display: flex;
  align-items: center;
  width: 20%;
  padding: 10px 10px;
  color: var(--full-blue);
  font-family: "BeatriceMedium";
}

@media screen and (max-width: 768px) {
  .order-header-item {
    padding: 7.5px 7.5px;
  }
}

.order-header-item__customer {
  width: 27.5%;
}

.order-header-item__checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
}

.order-item__checkbox-hint {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 100%;
  animation-name: higlight-checkbox;
  animation-duration: 1.8s;
  animation-iteration-count: infinite;
  transform-origin: 50% 50%;
  pointer-events: none;
}

@keyframes higlight-checkbox {
  0% {
    transform: scale(0.8);
    opacity: 0;
    box-shadow: 0px 0px 0px var(--sky-blue);
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(0.8);
    opacity: 0;
    box-shadow: 0px 0px 15px var(--sky-blue);
  }
}

.order-wrap {
  position: relative;
  width: 75%;
  margin: 0 auto;
  margin-top: 60px;
}

@media screen and (max-width: 992px) {
  .order-wrap {
    width: 100%;
  }
}
@media screen and (max-width: 768px) {
  .order-wrap {
    width: 100%;
    margin-top: 30px;
    font-size: 0.9em;
  }
}

.order-item__checkbox {
  display: none;
}

.order-item__checkbox-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  border: 1px solid #dedede;
  width: 25px;
  height: 25px;
}

@media screen and (max-width: 576px) {
  .order-item__checkbox-icon {
    height: 15px;
    width: 15px;
  }
}

.order-item__carrier-logo {
  max-width: 50px;
  max-height: 20px;
}

.order-item__checkbox-label input:checked ~ .order-item__checkbox-icon::after {
  background: var(--sky-blue);
  position: absolute;
  content: "";
  width: 13px;
  height: 13px;
  left: 5px;
  top: 5px;
  border-radius: 100%;
}

@media screen and (max-width: 576px) {
  .order-item__checkbox-label
    input:checked
    ~ .order-item__checkbox-icon::after {
    top: 2px;
    height: 9px;
    width: 9px;
    left: 2px;
  }
}

.order-item-wrap {
  overflow: hidden;
  width: 100%;
  padding: 0px;
}
/* Order Item */
.order-item {
  width: 100%;
  display: flex;
  border: 1px solid #eaeaea;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 0px 0px;
  margin: 10px 0;
  background: white;
  transition: all 1s;
}

.order-item-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 20%;
  padding: 10px 10px;
}

@media screen and (max-width: 768px) {
  .order-item-column {
    padding: 7.5px 7.5px;
  }
}

.order-item-column__customer {
  width: 27.5% !important;
}

.order-item-column__checkbox {
  width: 50px;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
}

.order-item-column__content-wrap {
  display: flex;
  width: 100%;
  align-items: center;
}

.order-item__small-text,
.order-item__text {
  max-width: 100%;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.order-item__small-text {
  margin-top: 5px;
}

.order-item__light {
  display: inline-block;
  margin-right: 5px;
  border-radius: 100%;
  width: 15px;
  height: 15px;
  background: #cccccc;
  flex-shrink: 0;
}

@media screen and (max-width: 576px) {
  .order-item__light {
    width: 10px;
    height: 10px;
  }
}

.order-item__light--active {
  background: rgb(127, 236, 127);
}

.order-item__text--active {
  background: #90ccff;
  border: 3px solid #1d97ff;
  border-radius: 25px;
  padding: 0 8px;
}

@media screen and (max-width: 576px) {
  .order-item__text--active {
    padding: 0 4px;
    margin-top: -4px;
  }
}

.fade-enter, .fade-leave-to
/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.fade-leave-active {
  position: absolute;
}
</style>
